import { TBrokerConfig } from '../../../types/broker';
import { useApplicationContext } from '../../../utils/withApplicationContext';

export const useBrokerConfig = (): TBrokerConfig => {
  const { config } = useApplicationContext();

  const brokerConfig: TBrokerConfig | null = config.get('newbuildingBroker');

  return {
    enabled: brokerConfig?.enabled || false,
  };
};
